import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetAgentsIncludesInArray = async (AgentsIds = []) => {
  try {
    let dataToReturn = [];
    for (let index = 0; index < AgentsIds.length; index++) {
      const agentsDoc = doc(
        db,
        "clients",
        getLocalStorageItem("bid"),
        "agents",
        AgentsIds[index]
      );

      const agentsSnapshot = await getDoc(agentsDoc);
      dataToReturn.push({
        ...agentsSnapshot.data(),
        id: agentsSnapshot.id,
      });
    }
    return dataToReturn;
  } catch (error) {
    console.log(error);
  }
};

export default GetAgentsIncludesInArray;
